import React, {useEffect, useState} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../../Univ.js'
function Pupils(props) {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [pupilData, setpupilData] = useState([]);
    const [nurseData, setnurseData] = useState({
        "ip": '',
        "leftsize": '',
        "lreaction": '',
        "rreaction": '',
        "rightsize": '',
        "notes": '',
        "pupil_time": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    useEffect(() => {
        fetchpupilData();
    }, []);
    function fetchpupilData() {
        axios.get(baseUrl + "view-pupils/" + ip_id + "/")
            .then(response => {
                setpupilData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const formSubmit = (e) => {
        e.preventDefault();
        const leftsize = document.getElementById("leftsize").value;
        const lreaction = document.getElementById("lreaction").value;
        const rightsize = document.getElementById("rightsize").value;
        const rreaction = document.getElementById("rreaction").value;
        const notes = document.getElementById("notes").value;
        const pupil_time = document.getElementById("pupil_time").value;
        const _formData = new FormData();
        _formData.append('ip', ip_id);
        _formData.append('leftsize', leftsize);
        _formData.append('lreaction', lreaction);
        _formData.append('rightsize', rightsize);
        _formData.append('rreaction', rreaction);
        _formData.append('notes', notes);
        _formData.append('pupil_time', pupil_time);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}pupils-create/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'Notes Created Succesfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setnurseData({
                        ip: '',
                        notes: '',
                        pupil_time: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/nurse-pat-view/' + ip_id + '/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-pupils/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                    setTimeout(() => {
                        window.location.href = ('/pupils/' + ip_id + '/');
                    }, 2000);
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Primary Consultant - Dr.{ipData.map(row => row.primary_consult.consultant)}
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip_id}</td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-eye" aria-hidden="true" style={{color: 'red'}}></i>
                    Pupils
                </h3>
                <form>
                    <div className="row">
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Left Size: </label>
                            <select className="form-control"
                                    name="leftsize" id="leftsize">
                                <option>Select</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Left Reaction: </label>
                            <select className="form-control"
                                    name="lreaction" id="lreaction">
                                <option>Select</option>
                                <option value="R">R</option>
                                <option value="PIN">PIN</option>
                                <option value="SR">SR</option>
                                <option value="NR">NR</option>
                                <option value="DIA-R">DIA-R</option>
                                <option value="DIA-NR">DIA-NR</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Right Size: </label>
                            <select className="form-control"
                                    name="rightsize" id="rightsize">
                                <option>Select</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Right Reaction: </label>
                            <select className="form-control"
                                    name="rreaction" id="rreaction">
                                <option>Select</option>
                                <option value="R">R</option>
                                <option value="PIN">PIN</option>
                                <option value="SR">SR</option>
                                <option value="NR">NR</option>
                                <option value="DIA-R">DIA-R</option>
                                <option value="DIA-NR">DIA-NR</option>
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="Notes" className="form-label">Notes : </label>
                            <textarea
                                className="no-comma form-control"
                                tabIndex="0"
                                name="notes"
                                id="notes"
                                required
                                rows={7} // Increase the number of rows to 4
                                cols={90} // Increase the number of columns to 30
                            ></textarea>
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
                            <DatePicker className="form-control" name="pupil_time" id="pupil_time"
                                        selected={selectedDateTime}
                                        onChange={handleDateTimeChange}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='ms-5 mb-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </form>
                <div className="card card-body">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-eye" aria-hidden="true" style={{color: 'red'}}></i>
                        Pupils History
                        <i className="fa-brands fa-discourse"></i>
                    </h3>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Date</th>
                                <th colSpan='5'>Notes</th>
                                <th>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            {pupilData.map((dis, index) => (
                                <tr>
                                    <td>{formatDateTime(dis.pupil_time)}</td>
                                    <td>Left Size : {dis.leftsize}</td>
                                    <td>Left Reaction : {dis.lreaction}</td>
                                    <td>Right Size : {dis.rightsize}</td>
                                    <td>Right Reaction : {dis.rreaction}</td>
                                    <td>{dis.notes}</td>
                                    <td>
                                        <button className="btn btn-danger" type="button"
                                                onClick={() => handleDelete(dis.id)}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Pupils;